import { css } from '@emotion/react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React from 'react';

import Theme from '../../../themes';
import CTAButton from '../../CTAButton';

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 20px;
  .oc-cta-button {
    margin-right: 5%;
  }
`;

const TabControls = ({ isLast, onNext, onPrevious, isFirst, t }) => {
  const cssThemeOverrides = css`
    background: ${Theme.colors.brand};
    border: 1px solid ${Theme.colors.brand};
    font-family: ${Theme.fonts.body};

    &:hover,
    &:focus {
      color: ${Theme.colors.brand};
    }
  `;

  return (
    <ButtonContainer>
      {!isFirst && (
        <CTAButton
          type="button"
          className="oc-cta-button"
          href="#"
          onClick={onPrevious}
          text={t('previous')}
          css={cssThemeOverrides}
        />
      )}
      {!isLast && (
        <CTAButton
          type="button"
          className="oc-cta-button"
          href="#"
          onClick={onNext}
          text={t('next')}
          css={cssThemeOverrides}
        />
      )}
      {isLast && (
        <CTAButton
          className="oc-cta-button"
          element="button"
          text={t('submit')}
          type="submit"
          css={cssThemeOverrides}
        />
      )}
    </ButtonContainer>
  );
};

TabControls.propTypes = {
  isLast: PropTypes.bool,
  isFirst: PropTypes.bool,
  onPrevious: PropTypes.func,
  onNext: PropTypes.func,
  t: PropTypes.func,
};

TabControls.defaultProps = {
  isLast: false,
  isFirst: false,
  onNext: () => {},
  onPrevious: () => {},
  t: () => {},
};

export default TabControls;
